import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function ConnectedApps() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["connected-apps"], queryFn: () => api.get("/me/connected-apps").then((r) => r.data.items) });
  const disconnect = async (g) => {
    if (!window.confirm(`Disconnect ${g.app.name}? It loses access immediately.`)) return;
    try { await api.delete(`/me/connected-apps/${g.grant_id}`); toast.success("Disconnected"); qc.invalidateQueries({ queryKey: ["connected-apps"] }); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <section className="panel space-y-4 p-6" data-testid="connected-apps">
      <div className="flex flex-wrap items-center justify-between gap-2"><p className="eyebrow">Connected apps</p>
        <Link to="/developers/apps" className="text-xs text-amber-300 underline" data-testid="settings-developer-portal-link">Building an app? Open the developer portal</Link></div>
      {data.map((g) => (
        <div key={g.grant_id} className="flex flex-wrap items-start justify-between gap-3 border-t border-[#2A3447] pt-3" data-testid={`connected-app-${g.grant_id}`}>
          <div className="min-w-0"><p className="font-heading text-amber-100">{g.app.name}</p>
            <p className="text-xs text-slate-500">by @{g.app.owner?.username} · connected {g.created_at.slice(0, 10)} · last used {g.last_used_at?.slice(0, 10) || "never"}</p>
            <p className="mt-1 break-words font-mono text-[11px] text-slate-400">{g.scopes.map((s) => s.scope).join(" · ")}</p></div>
          <button className="btn-outline text-xs text-red-300" onClick={() => disconnect(g)} data-testid={`connected-app-disconnect-${g.grant_id}`}>Disconnect</button>
        </div>
      ))}
      {!data.length && <p className="text-sm text-slate-500" data-testid="connected-apps-empty">You have not authorised any applications.</p>}
    </section>
  );
}
